import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class SpinnerService {
    private show: boolean;
    private count: number;
    statusChange$ = new Subject<boolean>();
    disabled: boolean = false;
    constructor() {
        this.count = 0;
        this.show = false;
    }

    incrementCount() {
        this.count++;
        if (!this.disabled) {
          this.setTrue();
        }
        this.statusChange$.next(this.spinnerStatus);
    }

    get spinnerStatus(): boolean {
        return this.show;
    }

    decrementCount() {
        if (this.count !== 0) {
            this.count--;
        } else {
            this.count = 0;
        }
        this.checkStatus();
    }

    private setTrue() {
        this.show = true;
    }

    private setFalse() {
        this.show = false;
    }

    private checkStatus() {
        if (this.count === 0) {
            this.setFalse();
        }
        this.statusChange$.next(this.spinnerStatus);
    }

    disable() {
      this.disabled = true;
    }

    enable() {
      this.disabled = false;
    }

    stop() {
        this.count = 0;
        this.setFalse();
        this.statusChange$.next(this.spinnerStatus);
    }
}
